(() => {
  const scrollTrack = (track, direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.85, 280), behavior: 'smooth' });
  const bindHero = (root) => root.querySelectorAll('[data-vc-hero]').forEach((hero) => {
    const track = hero.querySelector('[data-vc-hero-track]');
    if (!track) return;
    const previous = hero.querySelector('[data-vc-hero-prev]');
    const next = hero.querySelector('[data-vc-hero-next]');
    if (previous) previous.addEventListener('click', () => scrollTrack(track, -1));
    if (next) next.addEventListener('click', () => scrollTrack(track, 1));
    const dots = hero.querySelectorAll('[data-vc-hero-dot]');
    if (!dots.length) return;
    dots.forEach((dot) => dot.addEventListener('click', () => {
      const item = track.children[Number(dot.dataset.vcHeroDot)];
      if (item) item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }));
  });
  const bindCarousels = (root) => root.querySelectorAll('[data-vc-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-vc-carousel-track]');
    if (!track) return;
    const previous = carousel.querySelector('[data-vc-carousel-prev]');
    const next = carousel.querySelector('[data-vc-carousel-next]');
    if (previous) previous.addEventListener('click', () => scrollTrack(track, -1));
    if (next) next.addEventListener('click', () => scrollTrack(track, 1));
  });
  const bindCompare = (root) => root.querySelectorAll('[data-vc-compare]').forEach((compare) => {
    const overlay = compare.querySelector('[data-vc-compare-overlay]');
    const handle = compare.querySelector('[data-vc-compare-handle]');
    if (!overlay || !handle) return;
    let value = 50;
    const setPosition = (nextValue) => {
      value = Math.max(0, Math.min(100, nextValue));
      overlay.style.clipPath = 'inset(0 ' + (100 - value) + '% 0 0)';
      handle.style.left = value + '%';
      compare.setAttribute('aria-valuenow', String(Math.round(value)));
      compare.setAttribute('aria-valuetext', Math.round(value) + '% built vehicle visible');
    };
    const fromPointer = (event) => {
      const rect = compare.getBoundingClientRect();
      setPosition(((event.clientX - rect.left) / rect.width) * 100);
    };
    compare.addEventListener('pointerdown', (event) => { compare.setPointerCapture(event.pointerId); fromPointer(event); });
    compare.addEventListener('pointermove', (event) => { if (compare.hasPointerCapture(event.pointerId)) fromPointer(event); });
    compare.addEventListener('pointerup', (event) => { if (compare.hasPointerCapture(event.pointerId)) compare.releasePointerCapture(event.pointerId); });
    compare.addEventListener('pointercancel', (event) => { if (compare.hasPointerCapture(event.pointerId)) compare.releasePointerCapture(event.pointerId); });
    compare.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); setPosition(value - 5); }
      if (event.key === 'ArrowRight') { event.preventDefault(); setPosition(value + 5); }
      if (event.key === 'Home') { event.preventDefault(); setPosition(0); }
      if (event.key === 'End') { event.preventDefault(); setPosition(100); }
    });
    setPosition(value);
  });
  const initialise = (scope = document) => {
    const roots = scope.matches && scope.matches('[data-vehicle-content-page]') ? [scope] : scope.querySelectorAll ? scope.querySelectorAll('[data-vehicle-content-page]') : [];
    roots.forEach((root) => {
      if (root.dataset.vcInitialised === 'true') return;
      root.dataset.vcInitialised = 'true';
      bindHero(root); bindCarousels(root); bindCompare(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true }); else initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
